// libs/paypal.ts
import "client-only";

const PAYPAL_KEY = process.env.NEXT_PUBLIC_PAYPAL_KEY;

if (PAYPAL_KEY === undefined) {
  throw new Error("NEXT_PUBLIC_PAYPAL_KEY not set");
}

const loadPayPalScript = (checkoutType: string = "normal"): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    // Remove any existing PayPal script
    const existingScript = document.getElementById("paypal-sdk");

    if (existingScript) {
      existingScript?.parentNode?.removeChild(existingScript);
    }

    // Create a new script element
    const script = document.createElement("script");
    script.id = "paypal-sdk";

    script.src = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_KEY}&vault=${
      checkoutType === "subscription" ? "true" : "false"
    }${checkoutType === "subscription" ? "&intent=subscription" : ""}`;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load the PayPal SDK"));

    // Append the script to the document head
    document.head.appendChild(script);
  });
};

export default loadPayPalScript;
